import { create } from 'zustand';

export type DocPreview = {
  kind: 'pdf' | 'image';
  name: string;
  meta?: string;
  issuer?: string;
  long?: boolean;
  rows?: Array<[string, string]>;
};

type State = {
  open: boolean;
  doc: DocPreview | null;
  show: (doc: DocPreview) => void;
  close: () => void;
};

export const useDocPreviewStore = create<State>((set) => ({
  open: false,
  doc: null,
  show: (doc) => set({ open: true, doc }),
  close: () => set({ open: false }),
}));

export const openDocPreview = (doc: DocPreview) => useDocPreviewStore.getState().show(doc);
